
import * as types from './actionTypes';

export const getCosts = (params) => ({type: types.COST_LIST_GET, params });

export const getCostsSuccess = (payload) => ({type: types.COST_LIST_SUCCESS, payload})

export const getCostsFail = (error) => ({ type: types.COST_LIST_FAIL, error });
